import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

import Icon from './../Icons'

class CancelConfirmation extends React.Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
    this.clickHandler = this.clickHandler.bind(this)
    this.handleEscape = this.handleEscape.bind(this)
  }

  componentDidMount() {
    window.addEventListener('click', this.clickHandler)
    window.addEventListener('keydown', this.handleEscape)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickHandler)
    window.removeEventListener('keydown', this.handleEscape)
  }

  handleEscape(e) {
    e = e || window.event
    if (e.keyCode === 27) {
      this.handleClose()
    }
  }

  clickHandler(e) {
    const className = $(e.target).attr('class')
    if (className && className.trim() === 'ctp-cancel-confirmation') {
      this.handleClose()
    }
  }
  handleClose(_e) {
    this.props.onUpdate('', null)
  }
  render() {
    return (
      <div className="ctp-cancel-confirmation">
        <div className="ctp-cancel-confirmation-window">
          <div className="ctp-cancel-confirmation-window__header">
            <h1> Cancelled </h1>
            <div className="ctp-cancel-confirmation-window__close" onClick={this.handleClose}>
              <Icon icon="cross" />
            </div>
          </div>
          <div className="ctp-cancel-confirmation-window__body">
            <p>Appointment cancelled.</p>
          </div>
        </div>
      </div>
    )
  }
}

CancelConfirmation.propTypes = {
  onUpdate: PropTypes.func,
}

export default CancelConfirmation
